require('smoothscroll-polyfill').polyfill()
